import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const RealSwitch = ({ on, onChange, testid, what }) => {
  const [ask, setAsk] = useState(false);
  const [phrase, setPhrase] = useState("");
  return (
    <>
      <div className="flex items-center gap-2 text-xs font-semibold">
        <span className={on ? "text-slate-500" : "text-[var(--cyan)]"}>Paper</span>
        <Switch checked={on} onCheckedChange={(v) => (v ? setAsk(true) : onChange(false))} data-testid={testid} />
        <span className={on ? "text-amber-300" : "text-slate-500"}>Real</span>
      </div>
      <Dialog open={ask} onOpenChange={setAsk}>
        <DialogContent className="bg-[var(--card)] border-[var(--line)]">
          <DialogHeader><DialogTitle>Trade real money?</DialogTitle>
            <DialogDescription>{what} will place REAL orders with your money. Every bet is sized from your balance, can lose 100%, and nothing is guaranteed. Type I UNDERSTAND to continue.</DialogDescription></DialogHeader>
          <Input value={phrase} onChange={(e) => setPhrase(e.target.value)} placeholder="I UNDERSTAND" className="h-11 bg-[var(--bg)] border-[var(--line)]" data-testid={`${testid}-phrase`} />
          <button className="btn-primary !bg-amber-400" disabled={phrase.trim().toUpperCase() !== "I UNDERSTAND"} data-testid={`${testid}-confirm`}
            onClick={async () => { await onChange(true, phrase); setAsk(false); setPhrase(""); }}>Switch to real money</button>
        </DialogContent>
      </Dialog>
    </>
  );
};
